export default __webpack_public_path__ + "static/media/Ghostfang.f42c24bc.jpg";